<template>
  <div class="w3-card">
  <div id="top">
    <user-header v-bind:user="convo.meta.creator" />
    
    <div style="padding-bottom: 5px">
      <div>
        <p class="w3-theme-dark">
          {{convo.title}}
        </p>
        <p class="w3-left-align">{{convo.body}}<br/><br/></p>
      </div>
    </div>

    <div>
      <convo-references v-bind:convo="convo" v-bind:isEditable="false" />
    </div>
    <br/>
    <div>
    <convo-tags v-bind:convo="convo" v-bind:isEditable="false" />
    <br/>
    </div>
  </div>

  <div>
    Statements: <edit-button v-bind:isEditing="true" @done="stopEdit()" />
    <div style='background-color: #c0e0e8; padding-top:5px; padding-bottom: 5px'>
      <div class="w3-container w3-white w3-round w3-margin" v-for="(statement) in convo.meta.statements" :key="statement.id">
      <statement-view v-bind:statement="statement" v-bind:buttonType="'convo-remove'" />
      </div>
    </div>

    <br />
    <div class="w3-container w3-card w3-white w3-round w3-margin-left w3-margin-bottom" v-for="(statement) in statements" :key="statement.id">
      <statement-view v-bind:statement="statement" v-bind:buttonType="'convo-add'" />
    </div>
  </div>

  <hr class="w3-clear">
  </div>
</template>

<script>
  import ConvoStatementEdit from "./ConvoStatementEdit.ts";

  export default ConvoStatementEdit;
</script>
